import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '~src/hooks/api/constants';
import { UseQueryLocalOptions } from '~src/config/queryClient';
import { getAdminFeedbackEntries } from './requests';
import { AdminFeedbackEntriesResponse, AdminFeedbackEntry, GetAdminFeedbackEntryPayload } from './types';

const useAdminFeedbackEntries = (
  payload: GetAdminFeedbackEntryPayload,
  options?: UseQueryLocalOptions<AdminFeedbackEntriesResponse, GetAdminFeedbackEntryPayload, AdminFeedbackEntry[]>,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.ADMIN_FEEDBACK_ENTRIES, payload],
    queryFn: () => getAdminFeedbackEntries(payload),
    select: data => data.items,
    enabled: !!payload.id,
    ...options,
  });

export default useAdminFeedbackEntries;
